const initialState = {
  auth: {
    loading: false,
    isAuthenticated: false,
  },
  register: {
    loading: false,
    data: {},
  }

}

export default initialState
